module.exports = __webpack_public_path__ + "static/img/boost-your-sales.ef29ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marketing/boost-your-sales.png
// module id = LWm5
// module chunks = 2